export function PageSkeleton() {
  return (
    <div style={{ padding: "2rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div
        style={{
          height: 28,
          width: "40%",
          background: "#1e293b",
          borderRadius: 6,
          animation: "pulse 1.5s ease-in-out infinite",
        }}
      />
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton items are positional
          key={i}
          style={{
            height: 48,
            background: "#1e293b",
            borderRadius: 6,
            opacity: 1 - i * 0.15,
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      ))}
      <style>{"@keyframes pulse { 0%, 100% { opacity: 0.6; } 50% { opacity: 1; } }"}</style>
    </div>
  );
}
